import { useTranslation } from "react-i18next";
import qs from "qs";
import { ApiConstant, KeyConstant, LangConstant } from "const";
import { useMutation, useQueryClient } from "react-query";
import { ApiUtils, HumpUtils, StorageUtils, SystemUtils } from "utils";

export default function useCreateChannel() {
  const { t: getLabel } = useTranslation();
  const queryClient = useQueryClient();

  const createChannelMutation = useMutation({
    mutationFn: async ({ onSuccess, accountId, ...data }) => {
      const currentAccountId = StorageUtils.getStoreData(KeyConstant.KEY_USER_ID);
      const payload = HumpUtils.decamelizeKeys(data);
      // ACCOUNT_ID must be sent as-is (uppercase) for the backend auth context (using logged-in admin account ID)
      payload.ACCOUNT_ID = currentAccountId || accountId;

      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.POST_CREATE_CHANNEL,
        qs.stringify(payload, { arrayFormat: "brackets" }),
      );
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onSuccess }) => {
      if (response.status === ApiConstant.STT_OK) {
        SystemUtils.appendNotification(getLabel("TXT_CREATE_CHANNEL_SUCCESS"), "success");
        queryClient.invalidateQueries([ApiConstant.REACT_QUERY_KEYS.getChannelList]);
        if (onSuccess) onSuccess();
      } else if (response.error) {
        const errorMsg =
          response.error === "only admin can create channel"
            ? "Chỉ Quản trị viên mới có quyền tạo kênh"
            : response.error;
        SystemUtils.appendNotification(errorMsg, "error");
      } else if (response.status === ApiConstant.STT_BAD_REQUEST) {
        SystemUtils.appendNotification(getLabel("TXT_CHANNEL_DUPLICATED"), "error");
      } else {
        SystemUtils.appendNotification(getLabel("TXT_CREATE_CHANNEL_FAIL"), "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const createChannel = payload => {
    createChannelMutation.mutate(payload);
  };

  return { createChannel, isLoading: createChannelMutation.isLoading };
}
